module.exports = __webpack_public_path__ + "img/companyPay.64d7cefa.png";